"use client";

import { useState, useEffect, useCallback } from "react";
import type { OddsFormat } from "@/utils/calculators/odds-utils";

const STORAGE_KEY = "optimizer:oddsFormat";
const DEFAULT_FORMAT: OddsFormat = "american";
const SUPPORTED_FORMATS: OddsFormat[] = ["american", "decimal", "cents"];

export function useOddsFormatPreference() {
  const [format, setFormatState] = useState<OddsFormat>(DEFAULT_FORMAT);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    if (typeof window === "undefined") return;
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored && SUPPORTED_FORMATS.includes(stored as OddsFormat)) {
        setFormatState(stored as OddsFormat);
      }
    } catch {
    }
  }, []);

  const setFormat = useCallback((newFormat: OddsFormat) => {
    if (!SUPPORTED_FORMATS.includes(newFormat)) return;
    setFormatState(newFormat);
    if (typeof window !== "undefined") {
      try {
        window.localStorage.setItem(STORAGE_KEY, newFormat);
      } catch {
      }
    }
  }, []);

  return { format, setFormat, mounted };
}
